<template>
  <div>
    <div class="main">
      <div class="mail"
           v-for="(l,index) in list"
           :key="index"
           @click="checkout(l)">
        <img class="mail-icon"
             :src="laba"
             alt="">
        <div class="mail-box">
          <!-- <p :class="l.is_read == 0 ? 'mail-title unread-title' : 'mail-title'"> -->
          <div class="title-box">
            <p class="mail-title">
              <span>{{l.title}}</span> <br/>
              <span style="font-size:14px;">{{l.created_at}}</span>
            </p>
            <span class="mail-state"
                  v-if="l.is_read == 0">未读</span>
          </div>

          <p class="mail-info info-hide">{{l.content}}</p>
        </div>
      </div>
      <div class="text-center">
        <Page class-name="pages"
              :total="total"
              prev-text="上一页"
              next-text="下一页"
              show-elevator
              show-total
              :page-size="15"
              @on-change="changePage" />
      </div>

    </div>
    <div v-show="openFlag"
         class="bg"
         @click="closeBox"></div>
    <div v-show="openFlag"
         class="mail-alert">
      <img class="mail-alert-icon"
           :src="laba"
           alt="">
      <h5>{{m.title}} {{m.time}}</h5>
      <p class="mail-content" v-html="setDoctorName(m.content)"></p>
      <router-link v-if="m.title === '健康管理服务合同'"
                   :to="'/myfile'" style="font-size: 18px;">点击跳转至“我的资料”</router-link>
      <router-link v-else-if="m.pay" target="_blank"
                   :to="'/pay/' + m.id" style="font-size: 18px;">跳转到支付页面</router-link>
      <button @click="closeBox" class="clone-style">关闭</button>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import laba from '@/assets/images/mail/icon-mail.png';
import axios from '@/api/axios'
import * as apis from '@/api/mail.js'
export default {
  data () {
    return {
      laba: laba,
      modal: false,
      list: [],
      openFlag: false,
      m: {
        id: 0,
        title: '',
        time: '',
        content: '',
        pay: false
      },
      total: 0,
      prev_page: '', //上一页
      next_page: '', //下一页
    }
  },
  mounted () {
    this.getMails();
    //pay_message_id  0原来的内容 1支付消息    查看详情/去支付
    ////api/v1/web/letter/get_pay_index
  },
  computed: {
    ...mapState({
      mail: state => state.mail,
    })
  },
  methods: {
    setDoctorName (name) {
      if (name) {
        return name.replace(/\n/g, "<br/>");
      } else {
        return ''
      }
    },
    async getMails () {
      let res = await apis.getAllMailList({});
      if (res.code == 200) {
        this.list = res.data.data;
        this.total = res.data.total;
        this.next_page = res.data.next_page_url;
        // setTimeout(() => {
        //     this.getMails();
        // }, 60000);
      }
    },
    async checkout (item) {
      console.log(item);
      // if(item.pay_message_id == 0){
      //普通消息
      this.modal = true;
      let items = item;
      this.openFlag = true;
      this.m.id = item.id;
      this.m.title = item.title;
      this.m.time = item.created_at;
      this.m.content = item.content;
      if (item.pay_message_id != 0) {
        //支付消息
        this.m.pay = true;
      } else {
        this.m.pay = false;
      }
      // }else{
      //     //支付消息
      //     this.getPayMessage(item.pay_message_id);
      // }

      if (item.is_read != 1) {
        let data = {
          id: item.id
        };
        let res = await apis.readTheMail(data);
      }
    },

    async closeBox () {
      let id = this.m.id;
      this.$store.commit('MAIL', false);
      try {
        let data = {
          id: id
        };
        let res = await apis.readTheMail(data);
        if (res.code == 200) {
          this.list.forEach(item => {
            if (item.id == id) {
              item.is_read = 1;
            }
          })
          this.openFlag = false;
          this.$store.commit('MAIL', true);
          this.m = {
            id: 0,
            title: '',
            time: '',
            content: ''
          };
        } else {
          this.$Message.error(res.data.msg[0])
        }
      } catch (e) {
        console.log(e)
      }

    },
    changePage (index) {
      axios.get('api/v1/web/letter/get_all_mail?page=' + index).then((res) => {
        if (res.code == 200) {
          this.getUnread();
          window.scrollTo(0, 0);
          this.list = res.data.data;
        }
      });
    },
    async getUnread () {
      try {
        let res = await apis.getUnread({});
        if (res.code == 200) {
          this.unread = res.data.count
          // this.phone = res.data.phone;
          // this.time = res.data.text;
        }
      } catch (e) {
        console.log(e);
      }
    },
    ...mapMutations(['MAIL'])
  }
}
</script>
<style lang="less" scoped>
.clone-style {
  outline: none;
}
.clone-style::-moz-focus-inner {
  outline: none;
}
.main {
  width: 980px;
  margin: 30px auto 50px;
  .mail {
    background: #fff;
    border: 1px solid #dcdcdc;
    cursor: pointer;
    padding: 38px;
    margin-bottom: 20px;
    .mail-icon {
      float: left;
      width: 64px;
      height: 64px;
    }
    .mail-box {
      min-height: 64px;
      margin-left: 90px;
      .title-box {
        display: table;
        width: 100%;
      }
      .mail-title {
        font-size: 24px;
        color: #b3b3b3;
        line-height: 28px;
        margin-bottom: 22px;
        float: left;
      }
      .unread-title {
        color: #333;
        font-weight: bold;
      }
      .mail-state {
        float: left;
        width: 70px;
        height: 24px;
        background: url('../assets/images/mail/icon-read.png') no-repeat center;
        font-size: 18px;
        color: #fff;
        line-height: 24px;
        text-align: center;
        margin-left: 30px;
        margin-top: 10px;
      }
      .mail-info {
        font-size: 24px;
        color: #333130;
        line-height: 44px;
      }
      .info-hide {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
.bg {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 3;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.21);
}
.mail-alert {
  position: fixed;
  left: 50%;
  top: 100px;
  z-index: 101;
  width: 970px;
  height: auto;
  background: #fff;
  padding: 60px 80px 54px 120px;
  margin-left: -485px;
  h5 {
    font-size: 26px;
    color: #b3b3b3;
    line-height: 30px;
    margin-bottom: 40px;
  }
  p {
    font-size: 24px;
    color: #333;
    line-height: 46px;
    margin-bottom: 40px;
  }
  button {
    display: block;
    width: 124px;
    height: 36px;
    background: #c3c3c3;
    color: #fff;
    font-size: 12px;
    line-height: 36px;
    text-align: center;
    border-radius: 4px;
    border: none;
    margin: 0 auto;
  }
  .mail-alert-icon {
    position: absolute;
    left: 486px;
    top: -32px;
    width: 64px;
    height: 64px;
  }
  .mail-content {
    word-wrap:break-word;
    word-break:break-all;
    overflow: hidden;/*这个参数根据需要来绝对要不要*/
  }
}
</style>
